module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"everything":"Show all tests","filter":"Filter: "},"nl":{"everything":"Toon alle tests","filter":"Filter: "}}')
  delete Component.options._Ctor
}
